<footer class="site-footer">
          <div class="text-center">
              2020 &copy; Seotuners.com.
              <a href="#" class="go-top">
                  <i class="fa fa-angle-up"></i>
              </a>
          </div>
      </footer>